module.exports = __webpack_public_path__ + "assets/whatsAppIcon.c0ffd53d.svg";